import AccountAPI from '../../../api/AccountAPI';
import API from '../../../api/API';

export default {
  async login({
    commit
  }, data) {
    const response = await new AccountAPI().login(data);
    commit('SET_TOKEN', response);
  },

  async loginSSO({
    commit
  }, data) {
    const response = await new API().submit(
      "post",
      `${window.ENV.WEB_API_URL}/api/Account/LoginSSO/`,
      data
    );
    commit('SET_TOKEN', response);
  },

  async logout({commit, state}) {
    try {
      if (state.isAuthenticated) {
        await new AccountAPI().logout();
      }
    } catch (e) {
      console.error(e);
    } finally {
      commit('CLEAR_TOKEN');
    }
  },
};
